import { Button } from '@platform/components';
import ContentPanel from './ContentPanel';
import { H2, Description } from './utils';
import cx from 'classix';

const SignUpSection = ({
  title,
  description,
  signUpUrl,
  image,
}: {
  title: string;
  description: string;
  signUpUrl: string;
  image?: string;
}) => {
  return (
    <ContentPanel>
      <div className={cx(image ? 'contents sm:flex sm:my-8 sm:gap-16' : 'contents')}>
        <div className={cx(image ? 'contents sm:flex sm:flex-col ' : 'contents')}>
          <div className={cx(image ? 'text-left' : 'text-center')}>
            <H2>{title}</H2>
            <div className='sm:w-fit sm:mx-auto'>
              <Description>{description}</Description>
            </div>
          </div>
          {/* TODO: Correct href */}
          <div className={cx('sm:w-fit', !image && 'sm:mx-auto sm:-mt-8')}>
            <Button variant='primary' size='2xl' href={signUpUrl}>
              Sign Up
            </Button>
          </div>
        </div>
        {image && (
          <div className='-mx-4 self-stretch h-[488px] mt-16 sm:m-0 sm:w-full sm:h-full sm:-mt-16'>
            <img className='w-full h-full object-cover' src={image} />
          </div>
        )}
      </div>
    </ContentPanel>
  );
};

export default SignUpSection;
